<template>
  <div style="display: inline-block">
    <el-button icon="el-ali-icon-quanxuan" v-waves @click="showUpload" :disabled="hasPerm('import_excel')">{{this.$t('table.import')}}</el-button>
    <el-dialog title="导入" :visible="visible"  class="demo-box" width="40%">
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :multiple="false"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :limit = "parseInt('1')"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left:10px;margin-top: -10px" size="small" type="success" @click="submitUpload">上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过2MB</div>
          </el-upload>
          <button class="uploadCloseDialog" @click="closeDialogup">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
    </el-dialog>
    <transition name="fade">
      <div class="zh-load-view"
           v-if="showloadView"
           v-loading="showloadView"
           element-loading-text="拼命加载中">
      </div>
    </transition>
  </div>
</template>

<script>
  import service from '@/utils/server';
  // import axios from "axios";
  // const service = axios.create({
  //   // baseURL: "http://192.168.10.249:8020/hd-sz-wds",  // api的base_url
  //   baseURL: "http://127.0.0.1:8081/hd-sz-wds",  // api的base_url
  //   timeout: 5000 // 请求超时时间
  // });

  service.interceptors.request.use(config => {
    let token1 = localStorage.getItem("token_new");
    config.headers.Authorization = token1;
    return config;
  });
  export default {
    components: {},
      data() {
      return {
        fileList:[],
        submitObj:null,
        parmJson:null,
        doUpload:'#',
        visible:false,
        showloadView:false
      };
    },
    props:{templateName:{type:String,require:true}},
    methods: {
      showUpload(){
        this.visible=true;
      },
      showDialog(){
        this.visible =true;
      },
      closeDialogup() {
        this.visible =false;
      },
      beforeUpload(file){
        this.submitObj = new FormData();
        this.submitObj.append('uploadFileName', file.name);
        this.submitObj.append('uploadFile', file);
        this.submitObj.append('templateName',this.templateName);
        return false;
      },
      submitUpload() {
        this.showloadView = true
        this.$refs.upload.submit();
        let config = {
          responseType: 'blob',
          timeout: 500000, // 请求超时时间
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        let fileName = this.submitObj.get("uploadFileName");
        service.post("/excel/upload", this.submitObj, config).then( (res) => {
          console.log(res)
            if(res.type === "application/json"){
              var blob = new Blob([res]);
              var reader = new FileReader();
              reader.readAsText(blob, 'utf-8');
              var that = this;
              console.log(reader)
              reader.onload = function (e) {
                var resp = JSON.parse(reader.result);
                if(resp.code === 200){
                    that.$message({message: resp.msg, type: 'success'});
                    that.showloadView = false;
                    that.closeDialogup();
                    // that.$parent.queryListData(that.$parent.queryVo,false);
                    //that.$parent.queryList();
                    that.$emit('uploadQuery')
                }else{
                    that.$message({message: resp.msg, type: 'error'});
                    that.showloadView = false
                }
              }
            }else if(res.type === "application/vnd.ms-excel"){
                this.$message({message: "导入失败,具体原因请查看excel", type: 'error'});
                var blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob); //创建下载的链接
                downloadElement.href = href;
                downloadElement.download = fileName+"_error.xlsx"; //下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                document.body.removeChild(downloadElement); //下载完成移除元素
                window.URL.revokeObjectURL(href); //释放掉blob对象
                this.showloadView = false;
              this.closeDialogup();
            }
        }).catch(e => {
            this.$message({message: "导入异常，请稍后重试", type: 'error'});
            this.showloadView = false
              console.log(e);
          });
      },
    },
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .el-dialog {
    margin-top: 10% !important;
    /*.el-dialog__header {
      .el-dialog__headerbtn {
        display: none;
      }
    }*/

    .el-dialog__body {
      .uploadCloseDialog {
        color: #909399;
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 16px;
        z-index: 3000;
      }
    }
  }
  .zh-load-view{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    z-index: 3000;
    .el-loading-mask{
      background: rgba(255, 255, 255, 0.2);
      .el-loading-spinner{
        z-index: 4000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/Excel/upload.vue